import {Component, input, output} from '@angular/core';
import {CardModule} from 'primeng/card';
import {Button} from 'primeng/button';

@Component({
  selector: 'app-background-card',
  imports: [CardModule, Button],
  templateUrl: './background-card.component.html',
  styleUrl: './background-card.component.scss',
})
export class BackgroundCardComponent {
  title = input<string>();
  testId = input<string | undefined>();
  titleTestId = input<string | undefined>();
  styleClass = input('');

  actionLabel = input<string>();
  actionDisabled = input(false);
  actionStyleClass = input('');
  actionIcon = input<string>();
  actionTestId = input<string>();

  actionClick = output<void>();
}
